import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import cx from 'classnames'
import _ from 'lodash'

import NavigationBar from '../../../../scenes/Report/components/Workspace/components/NavigationBar'

import config from '../../../../../../config'

import './style.scss'

export default class ScrollableContent extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.array, IPropTypes.list, PropTypes.element]),
        entId: PropTypes.string.isRequired,
        moduleKey: PropTypes.string,
        scrollRefs: PropTypes.object,
        visibleBlocks: PropTypes.object,
    }

    constructor(props) {
        super(props)
        this.workspaceRef = React.createRef()
    }

    scrollTo = (ref) => {
        if (!ref) return null

        const workspaceDOMEl = this.workspaceRef.current

        workspaceDOMEl.scrollTop = ref.offsetTop
        return null
    }

    renderAll = (childrenArray) => {
        const { moduleKey, scrollRefs, entId, visibleBlocks } = this.props

        const childrenWithRefs = _.map(childrenArray, (child, index) =>
            React.cloneElement(child, { ref: (r) => (this._children[index] = child.ref ? child.ref(r) : r) })
        )

        return (
            <div
                className={cx('scrollable-content', moduleKey === config.modules.report.key && 'with-menu')}
                ref={this.workspaceRef}
            >
                {childrenWithRefs}

                {moduleKey === config.modules.report.key && (
                    <NavigationBar
                        id={entId}
                        moduleKey={moduleKey}
                        scrollTo={this.scrollTo}
                        scrollRefs={scrollRefs}
                        visibleBlocks={visibleBlocks}
                    />
                )}
            </div>
        )
    }

    render() {
        const { children, scrollRefs } = this.props

        // scrollTo func is required to be passed to the block component of report, which is nested
        // in a DOM node (block-wrap)
        const childrenWithProps = React.Children.map(children, (child) => {
            if (child && child.props) {
                const childrenOfChild = _.get(child, 'props.children', [])
                if (!_.isEmpty(childrenOfChild)) {
                    const componentsWithProps = React.Children.map(childrenOfChild, (componentOfChild) =>
                        React.cloneElement(componentOfChild, { scrollTo: this.scrollTo, scrollRefs })
                    )

                    return React.cloneElement(child, { children: componentsWithProps })
                }

                return React.cloneElement(child)
            }

            return child
        })
        const childrenArray = React.Children.toArray(childrenWithProps)
        this._children = _.fill(Array(childrenArray.length), null)

        return this.renderAll(childrenArray)
    }
}
